<template lang="pug">
  div
    h2(class="new-advert-subtitle mb-4") Выберите тип недвижимости:
    v-btn-toggle(mandatory v-model="type" class="toggle-buttons")
      v-row(no-gutters justify="start")
        v-btn(
          v-for="item in viewTypes"
          :key="item.id"
          :value="item.value")
          v-col
            img(
              :src="require(`@/assets/images/icons/type/${item.value === type ? item.activeIcon : item.icon}.svg`)",
              :alt="`${item.icon} icon`")
            div(class="v-btn-title") {{ item.title }}
</template>

<script>
export default {
  name: 'Types',
  props: {
    commerce: {
      type: Boolean,
      default: false
    },
    duration: {
      type: String,
      default: 'daily'
    }
  },
  data: () => ({
    type: 'apartment'
  }),
  watch: {
    type: {
      immediate: true,
      handler(value) {
        this.$emit('set-toggle-type', value)
      }
    }
  },
  computed: {
    viewTypes() {
      const types = [
        {
          id: '1',
          title: 'Квартира',
          value: 'apartment',
          icon: 'apartment',
          activeIcon: 'apartment_active'
        },
        {
          id: '2',
          title: 'Комната',
          value: 'room',
          icon: 'hotel',
          activeIcon: 'hotel_active'
        },
        {
          id: '3',
          title: 'Дом',
          value: 'house',
          icon: 'house',
          activeIcon: 'house_active'
        },
        {
          id: '4',
          title: 'Участок',
          value: 'area',
          icon: 'garden',
          activeIcon: 'garden_active'
        },
        {
          id: '5',
          title: 'Другое',
          value: 'other',
          icon: 'garage',
          activeIcon: 'garage_active'
        }
      ]
      let result

      if (this.commerce) {
        result = types.filter(item => item.value === 'other')
      } else {
        if (this.duration === 'sell') {
          result = this.removeTypeByIndex(types, 'room')
        } else {
          result = this.removeTypeByIndex(types, 'area')
        }
      }
      return result
    }
  },
  methods: {
    removeTypeByIndex(types, value) {
      const item = types.filter(item => item.value === value)
      let idx = types.indexOf(item[0])
      types.splice(idx, 1)
      return types
    }
  }
}
</script>
